import { useFormContext } from "react-hook-form";
import { ErrorMessage, TextInput, Typography } from "@/components/atoms";
import { clsx } from "@/utils";
import { AddClientFormData } from "../types";

export const LastNameField = ({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) => {
  const {
    register,
    formState: { errors },
  } = useFormContext<AddClientFormData>();

  return (
    <div className={clsx("flex flex-col gap-y-1", className)} {...props}>
      <Typography variant="paragraph">Last Name</Typography>
      <TextInput
        className="w-full"
        hasError={!!errors.lastName}
        placeholder="Enter Client's Last Name"
        maxLength={45}
        {...register("lastName")}
      />
      <ErrorMessage errors={errors} name="lastName" />
    </div>
  );
};
